module.exports = __webpack_public_path__ + "static/media/upgrade-analytics.c8ad4374.png";